// https://github.com/thumbsupep/proposal-upsert
// TODO: remove from `core-js@4`
require('../modules/esnext.map.update-or-insert');
require('../modules/esnext.map.upsert');
require('../modules/esnext.weak-map.upsert');



// WEBPACK FOOTER //
// /Users/kinfirm/Sites/mvgroup/wp-content/themes/mvgroup/node_modules/core-js/proposals/map-upsert.js